var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-container"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.list[_vm.type]))]),_c(_vm.type,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }